import React, { Fragment, useContext, useEffect, useState } from "react";
import { AppContext } from "../../context/AppContext";
import EnquiryListPanel from "./EnquiryListPanel";

function PendingEnquiries({ pendingList, keyword, searchDate }) {
  const { reservationLoading } = useContext(AppContext);
  const [displayList, setDisplayList] = useState(null);

  useEffect(() => {
    if (!pendingList) return;
    setDisplayList(pendingList);
  }, [pendingList]);

  useEffect(() => {
    filterData(searchDate, keyword);
  }, [searchDate, keyword, pendingList]);

  const filterData = (date, keyword) => {
    let filteredData = pendingList;

    const now = new Date();

    filteredData =
      filteredData &&
      filteredData.length != 0 &&
      Array.isArray(filteredData) &&
      filteredData.filter((data) => {
        const bookingDate = new Date(data.bookingTime);
        return bookingDate >= now;
      });

    if (date) {
      const today = new Date(date);
      filteredData = filteredData.filter((data) => {
        const bookingDate = new Date(data.bookingTime);
        return (
          bookingDate.getFullYear() === today.getFullYear() &&
          bookingDate.getMonth() === today.getMonth() &&
          bookingDate.getDate() === today.getDate()
        );
      });
    }

    if (keyword && keyword.length !== 0) {
      filteredData = filteredData.filter(
        (item) =>
          item.name.toLowerCase().includes(keyword.toLowerCase()) ||
          item.email.toLowerCase().includes(keyword.toLowerCase()) ||
          item.formattedID.toLowerCase().includes(keyword.toLowerCase()) ||
          item.phone.includes(keyword)
      );
    }

    setDisplayList(filteredData);
  };

  return (
    <Fragment>
      <EnquiryListPanel
        title="Pending reservations"
        items={displayList}
        loading={reservationLoading}
        emptyMessage="No Pending Enquiries"
        showStatus
      />
    </Fragment>
  );
}

export default PendingEnquiries;
